module.exports = __webpack_public_path__ + "static/media/codepenProfilePic.448fb7c9.jpg";